import {
  APP_BANNER_HEIGHT_VAR,
  Button,
  cn,
  IconButton,
  usePublishedElementHeight,
} from "@mozioinc/ui";
import { useTranslation } from "react-i18next";
import CloseSvg from "../components/assets/close.svg?react";
import SmallLogoSvg from "../components/assets/small-logo.svg?react";
import { useShowMobileAppDownload } from "../hooks/use-show-mobile-app-download";
import { onMobileAppDownloadClick } from "../utils/mobile-app";
import type { TransNamespace } from "../types";

export const MobileAppDownloadBanner = () => {
  const { t } = useTranslation<TransNamespace>("transfer:header");
  const { isBannerShown, dismissBanner } = useShowMobileAppDownload();
  // Publishes the same variable the redesigned banner does, so `layout.tsx` can
  // offset content with one expression in both flag states (DEC-02 / SNAV-23).
  // Called before the early return to keep hook order stable; with nothing
  // rendered the hook resets the variable to `0px`.
  const bannerRef = usePublishedElementHeight<HTMLDivElement>(
    APP_BANNER_HEIGHT_VAR,
    [isBannerShown],
  );

  if (!isBannerShown) return null;

  const descriptionText = t("Search, book, and track on your phone");
  const buttonText = t("use");
  return (
    <div
      ref={bannerRef}
      className="flex h-[var(--mz-header-height)] w-full items-center justify-center gap-4 border-b-2 bg-white p-3 text-sm animate-out fade-out"
    >
      <div className={"flex gap-3"}>
        <IconButton variant={"ghost"} onClick={dismissBanner}>
          <CloseSvg className={"text-neutral-800"} />
        </IconButton>
        <SmallLogoSvg className="text-[2rem]" />
      </div>
      <p
        className={cn(
          "font-medium",
          descriptionText.length > 40 && "text-xs leading-none",
        )}
      >
        {descriptionText}
      </p>
      <Button
        variant={"solid"}
        size="sm"
        className={cn(
          "rounded-2xl uppercase",
          buttonText.length > 4 && "text-xs",
        )}
        onClick={onMobileAppDownloadClick}
      >
        {buttonText}
      </Button>
    </div>
  );
};
